// Exports
export default {
	"SharingPreloaderWrapper": "SharingPreloaderWrapper_Uj7s4",
	"Preloader": "Preloader_cVPkM",
	"Title": "Title_bZHJa",
	"Message": "Message_M7iGB"
};
